import * as PartnerCostAction from './action';

import { takeLatest, put, call } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import { CORE_API, REPORT } from '../../config';

import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER} from '../../constants';

export function* uploadPartnerCostExcelFile(action) {
    let requestUrl = `${CORE_API}/partner/cost/upload`;
    try {
        const formData = new FormData();
        formData.append('file', action.data.file);
        const createResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });      
        yield put(PartnerCostAction.partnerCostUploadSuccess(createResult));
    } catch (err) {
       yield put(PartnerCostAction.partnerCostUploadFail(err))
    }
}

export function* uploadPartnerCostExcelFileSaga() {
    yield takeLatest(PartnerCostAction.PARTNER_COST_UPLOAD, uploadPartnerCostExcelFile);
}

export function* downloadCostExcel(action) {
    let requestUrl = `${CORE_API}/partner/fetch/all/cost`;
    try {
        const result = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(PartnerCostAction.downloadPartnerCostExcelSuccess(result));
    } catch (err) {
        yield put(PartnerCostAction.downloadPartnerCostExcelFail(err))
    }
}

export function* downloadCostExcelSaga() {
    yield takeLatest(PartnerCostAction.PARTNER_COST_DATA_DOWNLOAD_REQUEST, downloadCostExcel);
}

export function* downloadCostExcelTemplate(action) {
    let requestUrl = `${CORE_API}/partner/download/cost/template`;
    try {
        const result = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(PartnerCostAction.partnerCostTemplateDataDownloadSuccess(result));
    } catch (err) {
        yield put(PartnerCostAction.downloadPartnerCostExcelFail(err))
    }
}

export function* downloadCostExcelTemplateSaga() {
    yield takeLatest(PartnerCostAction.PARTNER_COST_DOWNLOAD_TEMPLATE_REQUEST, downloadCostExcelTemplate);
}